// generators/generateWordProblem.js
export function generateWordProblem() {
  const templates = [
    // Addition
    () => {
      const a = rand(6, 30), b = rand(6, 30);
      return {
        text: `Emma has ${a} marbles. She finds ${b} more marbles in the park. How many marbles does she have now?`,
        answer: a + b
      };
    },
    // Subtraction
    () => {
      const a = rand(20, 60), b = rand(6, 19);
      return {
        text: `Jason has ${a} candies. He gives ${b} to his friend. How many does he have left?`,
        answer: a - b
      };
    },
    // Multiplication
    () => {
      const a = rand(3, 8), b = rand(4, 10);
      return {
        text: `There are ${a} bags with ${b} apples each. How many apples in total?`,
        answer: a * b
      };
    },
    // Division
    () => {
      const b = rand(2, 7), total = b * rand(2, 7);
      return {
        text: `There are ${total} cookies shared equally among ${b} children. How many does each child get?`,
        answer: total / b
      };
    },
    // Ratio/Proportion
    () => {
      const a = rand(2, 7), b = rand(3, 6);
      return {
        text: `A recipe needs ${a} cups of flour for every ${b} cups of sugar. If you use ${b * 2} cups of sugar, how many cups of flour do you need?`,
        answer: a * 2
      };
    },
    // Unit conversion
    () => {
      const m = rand(1, 5), cm = m * 100 + rand(10, 50);
      return {
        text: `A ribbon is ${m} meters and ${cm % 100} centimeters long. How many centimeters is it in total?`,
        answer: m * 100 + (cm % 100)
      };
    },
    // Static complex
    () => ({
      text: "A train leaves City A at 9:00 AM and arrives at City B at 12:30 PM. How long is the journey in hours and minutes?",
      answer: "3 hours 30 minutes"
    }),
    // More types (add 30+ more templates for variety)
    // ...
  ];

  // Utility
  function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // Pick random template
  const tpl = templates[Math.floor(Math.random() * templates.length)];
  return tpl();
}
